import {
  VectorStyleLayer,
  VectorStyle
} from '../../../layer-type-services/vector-tile/twc-vector-tile.layer';
import { TwcProduct } from '../../../twc-products';

const TWC_TAFS_VECTOR_STYLE_LAYERS: VectorStyleLayer[] = [
  {
    layout: {
      'icon-image': [
        'concat', // Concatenate strings to make each TAF_WIND_BARB
        'TAF_Wind_Barb_',
        [
          'to-string',
          ['*', ['floor', ['/', ['*', ['get', 'wind_speed'], 1.94384], 5]], 5]
        ], // Wind speed in multiples of 5 by converting m/s to knots
        'kts_',
        ['get', 'flight_rule'] // Append flight rule at the end
      ],
      'icon-rotate': ['get', 'wind_direction'],
      'icon-size': {
        stops: [
          [1, 0.1],
          [2, 0.2],
          [3, 0.3],
          [4, 0.4],
          [5, 0.5],
          [6, 0.6],
          [7, 0.6],
          [8, 0.6],
          [9, 0.6],
          [10, 0.6],
          [11, 0.6],
          [12, 0.6],
          [13, 0.6],
          [14, 0.6],
          [15, 0.6],
          [16, 0.6]
        ]
      },
      'icon-allow-overlap': true
    },
    paint: {},
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'tafs',
    filter: [
      'all',
      ['has', 'wind_speed'],
      ['has', 'wind_direction'],
      ['has', 'flight_rule']
    ],
    type: 'symbol',
    maxzoom: 28
  }
];

export const TWC_TAFS_VECTOR_STYLE: VectorStyle = {
  layers: TWC_TAFS_VECTOR_STYLE_LAYERS,
  sprite: `assets/weather/sprites/TAFs`
};

export const TAFS_PRODUCT_DATA: TwcProduct = {
  id: 'tafs',
  defaultProductId: '6018',
  productName: 'Weather-TAFS-TWC',
  label: 'TAFs',
  weatherType: 'TAF',
  description: 'TWC product (vector) - Terminal Aerodrome Forecast (TAF)',
  series: 'Forecast',
  timeSlicePeriodInMinutes: 360,
  lodMax: 7,
  protocol: 'VectorTile',
  forecastTimeSlicePeriod: 360,
  flightLevelProductIds: {},
  zOrder: 90,
  layerSpecs: { vectorTile: { vectorStyle: TWC_TAFS_VECTOR_STYLE } }
};
